import { DEFAULT_GRID_RIGHT, SPACING_PER_X_CATEGORY } from "constants/chart.constants";

/**
 * Get max width for box in box plot before applying overflow ellipsis
 *
 * @param {number} chartWidth width of the chart
 * @param {number} numberOfCategories number of categories in the box plot
 * @returns {number} box max width
 */
export const calculateBoxPlotBarWidth = (
  chartWidth: number,
  numberOfCategories: number
): number => {
  const width =
    (chartWidth - SPACING_PER_X_CATEGORY - DEFAULT_GRID_RIGHT * numberOfCategories) /
    numberOfCategories;
  return width;
};
